module.exports = __webpack_public_path__ + "static/media/home.81d5ab58.jpg";